/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const OfficeMeasurementDefault = createEnum('OFFICE_MEASUREMENT_DEFAULT', {
  Millimeter: 'MM',
  Meter: 'M',
  Foot: 'FT',
});

export type OfficeMeasurementDefault = EnumSet<typeof OfficeMeasurementDefault>;
